import BaseTrackingView from '../../core/baseTrackingView';
import { getStorage } from '../../../home24/helpers/storage-factory';

export default BaseTrackingView.extend({
  events: {
    'submit form': 'onFormSubmit'
  },

  cookieCallbacks: {
    SearchEvent: 'afterSearchEvent'
  },

  initialize: function() {
    this.executeCookieCallbacks();
  },

  onFormSubmit: function() {
    getStorage().set('SearchEvent', 1);
  },

  afterSearchEvent: function(sData) {
    if (typeof window.dataLayer !== 'undefined' && sData == 1) {
      window.dataLayer.push({
        event: 'Internal Search'
      });
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/common/SearchField.js
 **/